import dayjs from 'dayjs';
import { history as historyRoute } from 'umi';
import {
  COUPON,
  NO_PRIZE,
  REAL_PRIZE,
  prizeLimitData,
  TAKE_THEIR,
  userPrizeLimitData,
  validateThousandNum,
} from '../constants';
import { fmtThousand } from '@/utils/comUtil';
import { OPT_ADD } from '@/constants';
import { UNDER_WAY } from '../constants';

import * as luckDrawViewSetting from '../services/luckDrawViewSetting';

export default {
  namespace: 'luckDrawViewSetting',
  state: {
    step: 0,
    status: 'add',
    deleteCache: [],
    storesChooseItemShowData: [],
    storesChooseItemShowDataReg: [],
    storesChooseItemShowDataRegConsume: [],
    limitArea: [],
    limitAreaReg: [],
    limitAreaRegConsume: [],
    limitOrderChannel: [],
    checkBoxValidateList: [], //基本信息页面展示
    prizeStatusModel: [],
    stepOneData: {
      name: '',
      description: '',
      type: '',
      hitRate: '',
      isLimit: 0,
      registerIsLimit: 0,
      consumeIsLimit: 0,
      orderChannelIsLimit: 0,
      beginDateTime: null,
      endDateTime: null,
    },
    stepTwoData: {
      isCanAddPrize: false,
      prizeModel: [],
      noPrizeModel: {
        title: '',
        notice: '',
        picUrl: '',
      },

      stepTwoSubmitData: [],
    },
    stepThreeData: {
      customBtn: {},
      pageFormData: {},
      prizePositionsInfo: [],
    },
  },

  effects: {
    *getLevels(_, { call, put }) {
      const response = yield call(luckDrawViewSetting.getLevels);
      yield put({
        type: 'save',
        payload: {
          memberLevels: response?.data,
        },
      });
    },
    *getRegionList(_, { call, put }) {
      const response = yield call(luckDrawViewSetting.getRegionList);
      yield put({
        type: 'save',
        payload: {
          regionList: response?.data,
        },
      });
    },
    *getAppIdList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(luckDrawViewSetting.getAppIdList, values);
      yield put({
        type: 'save',
        payload: {
          appIdList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *getMiniAppIdList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(luckDrawViewSetting.getMiniAppIdList, values);
      yield put({
        type: 'save',
        payload: {
          appIdList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *getStores({ payload: { values } }, { put, call }) {
      const response = yield call(luckDrawViewSetting.getStores, values);
      yield put({
        type: 'save',
        payload: {
          storesList: response.data.data,
          // storesPageSize: response.data.pageSize,//分页大小，10、50
          storesTotal: response.data.total, //总条数
          // storesPageNum: response.data.pageNum, //当前分页
        },
      });
    },
    *getStoresReg({ payload: { values } }, { put, call }) {
      const response = yield call(luckDrawViewSetting.getStores, values);
      yield put({
        type: 'save',
        payload: {
          storesListReg: response.data.data,
          // storesPageSize: response.data.pageSize,//分页大小，10、50
          storesTotalReg: response.data.total, //总条数
          // storesPageNum: response.data.pageNum, //当前分页
        },
      });
    },
    //保存第一步数据
    *saveStepOneData({ payload: { values } }, { put, select }) {
      const { status } = yield select((state) => state.luckDrawViewSetting);
      const checkBoxValidateList = yield select(
        (state) => state.luckDrawViewSetting.checkBoxValidateList,
      );

      const limitArea = yield select(
        (state) => state.luckDrawViewSetting.limitArea,
      );
      const limitAreaReg = yield select(
        (state) => state.luckDrawViewSetting.limitAreaReg,
      );
      const limitAreaRegConsume = yield select(
        (state) => state.luckDrawViewSetting.limitAreaRegConsume,
      );
      const limitOrderChannel = yield select(
        (state) => state.luckDrawViewSetting.limitOrderChannel,
      );
      const storesChooseItemShowData = yield select(
        (state) => state.luckDrawViewSetting.storesChooseItemShowData,
      );
      const storesChooseItemShowDataReg = yield select(
        (state) => state.luckDrawViewSetting.storesChooseItemShowDataReg,
      );
      const storesChooseItemShowDataRegConsume = yield select(
        (state) => state.luckDrawViewSetting.storesChooseItemShowDataRegConsume,
      );
      const stepTwoData = yield select(
        (state) => state.luckDrawViewSetting.stepTwoData,
      );

      const {
        isLimit,
        date,
        description,
        name,
        type,
        hitRate,
        registerIsLimit,
        consumeIsLimit,
        orderChannelIsLimit,
        dateReg,
      } = values;
      const stepOneData = {
        beginDateTime: dayjs(date.startDate).format('YYYY-MM-DD 00:00:00'),
        endDateTime: dayjs(date.endDate).format('YYYY-MM-DD 23:59:59'),
        registerBeginDateTime: dateReg.startDate
          ? dayjs(dateReg.startDate).format('YYYY-MM-DD 00:00:00')
          : null,
        registerEndDateTime: dateReg.endDate
          ? dayjs(dateReg.endDate).format('YYYY-MM-DD 23:59:59')
          : null,
        description,
        name,
        type,
        hitRate,
        orderChannelIsLimit,
      };
      checkBoxValidateList.forEach((item) => {
        stepOneData[item.name] = values[item.name];
        if (item.midName) {
          stepOneData[item.midName] = values[item.midName];
        }
        if (item.thirdName) {
          stepOneData[item.thirdName] = values[item.thirdName];
        }
      });
      if (isLimit === 'limit') {
        stepOneData.isLimit = 1;
        stepOneData.conditions = {
          regions: limitArea,
          stores: storesChooseItemShowData,
        };
      } else {
        stepOneData.isLimit = 0;
        stepOneData.conditions = {
          regions: [],
          stores: [],
        };
      }
      if (
        checkBoxValidateList.some((i) => i.name === 'registerDrawNum') &&
        registerIsLimit === 'limit'
      ) {
        stepOneData.registerIsLimit = 1;
        stepOneData.registerConditions = {
          regions: limitAreaReg,
          stores: storesChooseItemShowDataReg,
        };
      } else {
        stepOneData.registerIsLimit = 0;
        stepOneData.registerConditions = {
          regions: [],
          stores: [],
        };
      }
      //消费区域
      if (
        checkBoxValidateList.some((i) => i.name === 'paidAmount') &&
        consumeIsLimit === 'limit'
      ) {
        stepOneData.consumeIsLimit = 1;
        stepOneData.consumeConditions = {
          regions: limitAreaRegConsume,
          stores: storesChooseItemShowDataRegConsume,
        };
      } else {
        stepOneData.consumeIsLimit = 0;
        stepOneData.consumeConditions = {
          regions: [],
          stores: [],
        };
      }
      if (
        checkBoxValidateList.some((i) => i.name === 'paidAmount') &&
        orderChannelIsLimit === 'limit'
      ) {
        stepOneData.orderChannelIsLimit = 1;
        stepOneData.orderChannelConditions = limitOrderChannel;
      } else {
        stepOneData.orderChannelIsLimit = 0;
        stepOneData.orderChannelConditions = [];
      }
      if (status === 'add' && !stepTwoData?.prizeModel?.[0]?.picUrl) {
        const id = Date.now() + '_';
        yield put({
          type: 'save',
          payload: {
            step: 1,
            stepOneData,
            prizeStatusModel: [{ id, isOpen: true, currentState: 'add' }],
            stepTwoData: {
              isCanAddPrize: false,
              prizeModel: [{ id }],
            },
          },
        });
      } else {
        yield put({
          type: 'save',
          payload: {
            step: 1,
            stepOneData,
          },
        });
      }
    },
    //保存第二步数据
    *saveStepTwoData({ payload: { values } }, { put, select }) {
      const stepTwoData = yield select(
        (state) => state.luckDrawViewSetting.stepTwoData,
      );

      const { prizeModel, noPrizeItem = {} } = stepTwoData;
      const stepTwoSubmitData = prizeModel
        .map((item, index) => {
          const {
            // eslint-disable-next-line no-unused-vars
            id,
            // eslint-disable-next-line no-unused-vars
            currentStatus,
            couponInfo,
            changeCouponInfo,
            ...restParam
          } = item;
          //奖品数量去千分位
          let { type, sendType, quantity, winLimit, point, winNumLimit } = item;
          quantity = validateThousandNum(item.quantity);
          winLimit = validateThousandNum(item.winLimit);
          point = validateThousandNum(item.point);
          winNumLimit = validateThousandNum(item.winNumLimit) || '';
          let couponId;
          if (type === 'COUPON') {
            couponId = couponInfo?.couponId;
          } else if (type === 'REAL_PRIZE' && sendType === 'TAKE_THEIR') {
            couponId = changeCouponInfo?.couponId;
          }
          return {
            ...restParam,
            quantity,
            winLimit,
            point,
            couponId,
            winNumLimit,
            prizeTitle: item.title,
            prizeId: item?.prizeId,
            id: item?.prizeId || index + 1,
          };
        })
        .concat([
          {
            ...values,
            type: 'NO_PRIZE',
            prizeId: noPrizeItem?.prizeId,
            id: noPrizeItem?.prizeId || 12,
            prizeTitle: values.title,
          },
        ]);
      const stepThreeData = yield select(
        (state) => state.luckDrawViewSetting.stepThreeData,
      );
      //对比一下奖项位置与奖品
      const { prizePositionsInfo } = stepThreeData;
      const updatePrizePositionInfo = prizePositionsInfo?.map((item) => {
        const noChange = stepTwoSubmitData.some(
          (i) => i.title === item.prizeTitle,
        );
        if (!noChange) {
          const updatePrizeTitle = stepTwoSubmitData?.find(
            (it) => (it.prizeId || it.id) === item.id,
          )?.title;
          return { ...item, prizeTitle: updatePrizeTitle };
        }
        return { ...item };
      });
      yield put({
        type: 'save',
        payload: {
          stepTwoSubmitData,
          stepTwoData: {
            ...stepTwoData,
            noPrizeItem: {
              prizeId: noPrizeItem.prizeId || 12,
              ...values,
            },
          },
          step: 2,
          stepThreeData: {
            ...stepThreeData,
            prizePositionsInfo: updatePrizePositionInfo,
          },
        },
      });
    },
    //跟新每个奖项状态
    *updateStatus({ payload: { values } }, { put, select }) {
      const { id, newStatus } = values;
      const prizeStatusModel = yield select(
        (state) => state.luckDrawViewSetting.prizeStatusModel,
      );
      const newPrizeStatusModel = prizeStatusModel.map((item) => {
        if (item.id === id) {
          return item.currentStatus === 'finish'
            ? { ...item, currentStatus: newStatus }
            : item;
        }
        return item;
      });
      yield put({
        type: 'save',
        payload: {
          prizeStatusModel: newPrizeStatusModel,
        },
      });
    },
    //保存第三步数据
    *saveStepThreeData(
      { payload: { values, isSubmitData, id }, callback },
      { put, select, call },
    ) {
      const { status } = yield select((state) => state.luckDrawViewSetting);
      const stepThreeData = yield select(
        (state) => state.luckDrawViewSetting.stepThreeData,
      );
      const checkBoxValidateList = yield select(
        (state) => state.luckDrawViewSetting.checkBoxValidateList,
      );
      const stepOneData = yield select(
        (state) => state.luckDrawViewSetting.stepOneData,
      );
      const stepTwoSubmitData = yield select(
        (state) => state.luckDrawViewSetting.stepTwoSubmitData,
      );
      let { prizePositionsInfo } = stepThreeData;
      //将奖品位置里面没有奖品title的删掉
      prizePositionsInfo = prizePositionsInfo.filter((i) =>
        Boolean(i.prizeTitle),
      );
      const {
        title,
        pagePath,
        thumbUrl,
        backgroundPicUrl,
        startBtnPicUrl,
        wheelPicUrl,
        appid,
        ...buttonInfo
      } = values;
      const customBtn = { ...buttonInfo };
      let key =
        stepOneData.type === 'SLYDER_ADVENTURES'
          ? 'wheel'
          : stepOneData.type === 'SUDOKU'
          ? 'sudoku'
          : stepOneData.type === 'SCRATCH_CARD'
          ? 'scratch'
          : 'shake';
      const images = {
        [key]: { backgroundPicUrl, startBtnPicUrl, wheelPicUrl },
      };
      const miniProgramPage = { title, pagePath, thumbUrl };
      const submitData = {
        prizePositions: prizePositionsInfo,
        customBtn,
        miniProgramPage,
        images,
      };
      checkBoxValidateList.forEach((item) => {
        stepOneData[item.name] = validateThousandNum(stepOneData[item.name]);
        if (item.midName) {
          stepOneData[item.midName] = validateThousandNum(
            stepOneData[item.midName],
          );
        }
        if (item.thirdName) {
          stepOneData[item.thirdName] = validateThousandNum(
            stepOneData[item.thirdName],
          );
        }
      });
      yield put({
        type: 'save',
        payload: {
          stepOneData,
          stepThreeData: {
            ...stepThreeData,
            pageFormData: { ...values },
            customBtn,
          },
        },
      });
      const prizeNumList = stepTwoSubmitData
        ?.filter(
          (item) => item.type !== 'NO_PRIZE' && item.prizeId && item.quantity,
        )
        ?.map((item) => ({ prizeId: item.prizeId, quantity: item.quantity }));

      if (id) {
        const checkPrizeNumRes = yield call(luckDrawViewSetting.checkPrizeNum, {
          prizeNumList,
          id,
        });
        if (
          checkPrizeNumRes?.code === 0 &&
          checkPrizeNumRes?.data?.length > 0
        ) {
          return callback({ data: checkPrizeNumRes.data, isCheck: true });
        }
      }

      if (isSubmitData) {
        if (status === OPT_ADD) {
          yield put({
            type: 'addActivityLottery',
            payload: {
              values: { ...submitData, appid },
            },
            callback,
          });
        } else {
          yield put({
            type: 'updateActivityLottery',
            payload: {
              values: { ...submitData, appid, id },
            },
            callback,
          });
        }
      }
    },

    *addActivityLottery({ payload: { values }, callback }, { call, select }) {
      const { stepOneData, stepTwoSubmitData } = yield select(
        (state) => state.luckDrawViewSetting,
      );
      const {
        consumeConditions,
        consumeIsLimit,
        orderChannelIsLimit,
        ...newStepOneData
      } = stepOneData;
      newStepOneData.orderConditions = consumeConditions;
      newStepOneData.orderIsLimit = consumeIsLimit;
      newStepOneData.orderChannelIsLimit = orderChannelIsLimit;
      const response = yield call(luckDrawViewSetting.addActivityLottery, {
        ...newStepOneData,
        prizeModel: stepTwoSubmitData,
        ...values,
      });
      if (response.code === 0) {
        window.message.toast({
          type: 'success',
          message: '新增活动成功',
          title: '成功',
        });
        callback({
          ...stepOneData,
          prizeModel: stepTwoSubmitData,
          ...values,
        });
        historyRoute.goBack();
      } else {
        return callback && callback();
      }
    },

    *updateActivityLottery(
      { payload: { values }, callback },
      { call, select },
    ) {
      const { stepOneData, stepTwoSubmitData } = yield select(
        (state) => state.luckDrawViewSetting,
      );
      const { consumeConditions, consumeIsLimit, ...newStepOneData } =
        stepOneData;
      newStepOneData.orderConditions = consumeConditions;
      newStepOneData.orderIsLimit = consumeIsLimit;
      const response = yield call(luckDrawViewSetting.updateActivityLottery, {
        ...newStepOneData,
        prizeModel: stepTwoSubmitData,
        ...values,
      });
      if (response.code === 0) {
        window.message.toast({
          type: 'success',
          message: '编辑活动成功',
          title: '成功',
        });
        callback({
          ...stepOneData,
          prizeModel: stepTwoSubmitData,
          ...values,
        });
        historyRoute.goBack();
      } else {
        return callback && callback();
      }
    },

    //获取抽奖活动详情
    *getActivityLotteryDetail({ payload: { values } }, { put, call, select }) {
      const { data } = yield call(
        luckDrawViewSetting.getActivityLotteryDetail,
        values,
      );
      //会员等级列表和区域表需要保存一下
      const { memberLevels = [], regionList = [] } = yield select(
        (state) => state.luckDrawViewSetting,
      );
      const campaignStatus = yield select(
        (state) => state.luckDrawViewSetting?.campaignStatus,
      );
      const consumeConditions = data.orderConditions || {};
      const {
        prizeModel,
        prizePositions = [],
        miniProgramPage,
        images,
        customBtn,
        beginDateTime,
        endDateTime,
        conditions,
        appid,
        registerConditions,
        orderIsLimit,
        orderChannelConditions,
        ...restParam
      } = data;
      let wheel = images.wheel || {};
      if (restParam.type === 'SUDOKU') {
        wheel = images.sudoku || {};
      } else if (restParam.type === 'SCRATCH_CARD') {
        wheel = images.scratch || {};
      } else if (restParam.type === 'SHAKE_IT_OFF') {
        wheel = images.shake || {};
      }
      //第一步数据
      const stepOne = {
        ...restParam,
        beginDateTime: dayjs(beginDateTime).format('YYYY-MM-DD'),
        endDateTime: dayjs(endDateTime).format('YYYY-MM-DD'),
        consumeIsLimit: orderIsLimit,
      };
      let checkBoxValidateList = [];
      prizeLimitData.forEach((item) => {
        const { name, midName, thirdName } = item;
        if (stepOne[name] || stepOne[midName] || stepOne[thirdName]) {
          checkBoxValidateList.push(item);
          stepOne[name] = stepOne[name] ? fmtThousand(stepOne[name]) : '';
          if (stepOne[midName]) {
            stepOne[midName] = stepOne[midName]
              ? fmtThousand(stepOne[midName])
              : '';
          }
          if (stepOne[thirdName]) {
            stepOne[thirdName] = stepOne[thirdName]
              ? fmtThousand(stepOne[thirdName])
              : '';
          }
        }
      });
      userPrizeLimitData.forEach((item) => {
        const { name } = item;
        if (stepOne[name]) {
          stepOne[name] = fmtThousand(stepOne[name]);
          checkBoxValidateList.push(item);
        }
      });
      //第二步数据
      const noPrizeModel = prizeModel.find((i) => i.type === NO_PRIZE);
      const realPrizeModel = prizeModel.filter((i) => i.type !== NO_PRIZE);
      const prizeStatusModel = [];
      const prizeModels = realPrizeModel.map((prize, index) => {
        const {
          type,
          sendType,
          quantity,
          winLimit,
          winNumLimit,
          point,
          coupons = {},
          conditions: prizeConditions = {},
        } = prize;

        const prizeItem = {
          id: index + 1,
          ...prize,
          point: point ? fmtThousand(point) : point,
          quantity: quantity ? fmtThousand(quantity) : quantity,
          winLimit: winLimit ? fmtThousand(winLimit) : winLimit,
          winNumLimit: winNumLimit ? fmtThousand(winNumLimit) : winNumLimit,
          couponId: coupons?.couponId || null,
          isCanDelete: campaignStatus !== UNDER_WAY,
        };
        prizeStatusModel.push({
          currentStatus: 'finish',
          isOpen: false,
          id: index + 1,
        });
        if (!prizeConditions) {
          prizeItem.conditions = {
            regions: [],
            levels: [],
          };
        }
        if (type === COUPON) {
          prizeItem.couponInfo = coupons;
        } else if (type === REAL_PRIZE && sendType === TAKE_THEIR) {
          prizeItem.changeCouponInfo = coupons;
        }
        return prizeItem;
      });
      const stepTwo = {
        noPrizeItem: noPrizeModel,
        prizeModel: prizeModels,
        isCanAddPrize: Boolean(prizeModels.length < 11),
      };
      const stepThree = {
        customBtn,
        prizePositionsInfo: prizePositions,
        pageFormData: {
          ...miniProgramPage,
          ...wheel,
          ...customBtn,
          appid,
        },
      };

      yield put({
        type: 'save',
        payload: {
          step: 0,
          status: 'edit',
          prizeStatusModel,
          regionList,
          memberLevels,
          limitArea: conditions.regions,
          limitAreaReg: registerConditions?.regions || [],
          limitAreaRegConsume: consumeConditions?.regions || [], //------limitAreaRegConsume
          limitOrderChannel: orderChannelConditions || [],
          storesChooseItemShowData: conditions.stores,
          storesChooseItemShowDataReg: registerConditions?.stores || [],
          storesChooseItemShowDataRegConsume: consumeConditions?.stores || [], //------storesChooseItemShowDataRegConsume
          checkBoxValidateList,
          stepOneData: stepOne,
          stepTwoData: stepTwo,
          stepThreeData: stepThree,
          editBeginDateTime: dayjs(beginDateTime).format('YYYY-MM-DD'),
        },
      });
    },
    *deletePrize({ payload: { values } }, { put, select }) {
      const deleteCache = yield select(
        (state) => state.luckDrawViewSetting.deleteCache,
      ) || [];
      deleteCache.push(values.id);
      yield put({
        type: 'save',
        payload: {
          deleteCache: deleteCache,
        },
      });
    },
    *queryPrizeSendNum({ payload: { values }, callback }, { call }) {
      const response = yield call(
        luckDrawViewSetting.queryPrizeSendNum,
        values,
      );
      return callback(response);
    },
    //第二步跳转第一步的时候 奖项数据保存
    // *saveTemporaryData({ payload: { values } }, { put, select }) {
    //   const deleteCache = yield select(
    //     (state) => state.luckDrawViewSetting.deleteCache,
    //   ) || [];
    //   const stepTwoData = yield select(
    //     (state) => state.luckDrawViewSetting.stepTwoData,
    //   );
    //   const { prizeModel } = stepTwoData;

    //   const id = values.id;
    //   if (!deleteCache.some((i) => i === id)) {
    //     const updatePrizeModel = prizeModel.map((i) => {
    //       if (i.id === id) {
    //         return { ...i, ...values };
    //       }
    //       return i;
    //     });
    //     yield put({
    //       type: 'save',
    //       payload: {
    //         stepTwoData: {
    //           ...stepTwoData,
    //           prizeModel: updatePrizeModel,
    //         },
    //       },
    //     });
    //   }
    // },
    //也许还有用
    // *clearData(_, { put }) {
    //   yield put({
    //     type: 'save',
    //     payload: {
    //       stepTwoData: {
    //         step: 0,
    //         prizeStatusModel: [],
    //         regionList: [],
    //         memberLevels: [],
    //         limitArea: [],
    //         storesChooseItemShowData: [],
    //         checkBoxValidateList: [],
    //         stepOneData: {},
    //         stepTwoData: {
    //           prizeModel: [],
    //         },
    //         stepThreeData: {
    //           customBtn: {},
    //           pageFormData: {},
    //           prizePositionsInfo: [],
    //         },
    //       },
    //     },
    //   });
    // },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
    saveEach(state, action) {
      const s = { ...state.stepOneData, ...action.payload.stepOneData };
      return { ...state, stepOneData: { ...s } };
    },
  },

  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((props) => {
        const { opt: queryType, campaignStatus } = history.location?.query;
        if (
          props.pathname.includes('luck_draw_view_setting_add') ||
          props.pathname.includes('luck_draw_view_setting_edit') ||
          props.pathname.includes('luck_draw_view_setting_detail')
        ) {
          dispatch({
            type: 'save',
            payload: {
              status: queryType,
              campaignStatus, //活动状态
              step: 0,
              deleteCache: [],
              storesChooseItemShowData: [],
              storesChooseItemShowDataReg: [],
              storesChooseItemShowDataRegConsume: [],
              limitArea: [],
              limitAreaReg: [],
              limitAreaRegConsume: [],
              limitOrderChannel: [],
              checkBoxValidateList: [],
              stepOneData: {},
              editBeginDateTime: null,
              prizeStatusModel: [],
              stepTwoData: {
                isCanAddPrize: false,
                prizeModel: [],
                noPrizeModel: {
                  title: '',
                  notice: '',
                  picUrl: '',
                },
              },
              stepThreeData: {
                customBtn: {},
                pageFormData: {},
                prizePositionsInfo: [],
              },
            },
          });
        }
      });
    },
  },
};
